import { WILSONS_JOURNEY } from "./wilsonsJourney";
import { TIFFIN_GIRLS_JOURNEY } from "./tiffinGirlsJourney";
import { GRAVESEND_JOURNEY } from "./gravesendJourney";

/**
 * Hand-crafted parent guides. These override the generated pack for the same school.id.
 * Every other school with a numeric id still gets a generated guide via loadSchoolJourney.
 */
const JOURNEY_BY_ID = new Map([
  [WILSONS_JOURNEY.schoolId, WILSONS_JOURNEY],
  [TIFFIN_GIRLS_JOURNEY.schoolId, TIFFIN_GIRLS_JOURNEY],
  [GRAVESEND_JOURNEY.schoolId, GRAVESEND_JOURNEY],
]);

export const HAND_JOURNEY_SCHOOL_IDS = new Set(JOURNEY_BY_ID.keys());

/** @deprecated Prefer HAND_JOURNEY_SCHOOL_IDS; kept for older imports. */
export const JOURNEY_SCHOOL_IDS = HAND_JOURNEY_SCHOOL_IDS;

/** True when the school can open a School Guide (hand pack or generated). */
export function hasSchoolJourney(school) {
  const id = Number(school?.id);
  return Number.isFinite(id) && id > 0;
}

/** Hand pack only — null when the guide will be generated at load time. */
export function journeyForSchool(school) {
  const id = Number(school?.id);
  if (!Number.isFinite(id)) return null;
  return JOURNEY_BY_ID.get(id) || null;
}

export function isHandCraftedJourney(school) {
  const id = Number(school?.id);
  return Number.isFinite(id) && JOURNEY_BY_ID.has(id);
}
